import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRotate90Left12 from './IconRotate90Left12';
import IconRotate90Left16 from './IconRotate90Left16';
import IconRotate90Left20 from './IconRotate90Left20';
import IconRotate90Left24 from './IconRotate90Left24';
import IconRotate90Left32 from './IconRotate90Left32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRotate90Left = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRotate90Left12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRotate90Left16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRotate90Left20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRotate90Left24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRotate90Left32 {...props} />}
        </span>
    );
};
IconRotate90Left.displayName = 'FondueIconRotate90Left';

export default memo(IconRotate90Left);
